export default "<h1>Type12RichText list</h1>\n<spec-app-type12-rich-text-table [clickHandler]=\"createClickHandler()\"></spec-app-type12-rich-text-table>";